import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import DefaultScrollWithHeaderContent from '../../../../utils/DefaultScrollWithHeaderContent';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from "@material-ui/core";


const modules = {
    toolbar: [
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
    ],
};

const useStyles = makeStyles({
    root: {
        display: 'flex',

        '& .defaultScrollWithHeaderContent': {
            width: "100%",

            '& .ql-toolbar': {
                textAlign: "left",
            }
        }
    },
});

export default function CommentsTab(props) {

    const { assets, isLoading, comments, setComments } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [innerLoad, setInnerLoad] = useState({ emptyMessage: "", loadMessage: "Carregando ativos...", size: "small" });

    useEffect(() => {

        if (!assets?.length) return;

    }, [clientOn]);

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={isLoading ? innerLoad : null}>

                <ReactQuill style={{ width: "100%" }} theme="snow" modules={modules} value={comments} onChange={setComments} />
            </DefaultScrollWithHeaderContent>

        </div>
    );
}



